import ClassNames from 'classnames'
import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'
interface IWindow {
  localePath: { [key: string]: string }
  location: any
}

declare var window: IWindow

interface IProps {
  isOpen?: boolean
  setIsOpen?: (isOpen: boolean) => void
}

const Burger: React.VFC<IProps> = ({ isOpen, setIsOpen }) => {
  const [isBurgerOpen, setIsBurgerOpen] = React.useState(isOpen || false)
  React.useEffect(() => {
    if (setIsOpen) {
      setIsOpen(isBurgerOpen)
    }
  }, [isBurgerOpen])

  React.useEffect(() => {
    if (isOpen !== undefined) {
      setIsBurgerOpen(isOpen)
    }
  }, [isOpen])

  const onClick = () => setIsBurgerOpen(!isBurgerOpen)
  return (
    <BurgerIcon
      className={ClassNames('burger', { isOpen: isBurgerOpen })}
      onClick={onClick}
      aria-label="menu"
    >
      <SvgIcon name="menu" />
    </BurgerIcon>
  )
}

const BurgerIcon = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    margin-right: 20px;
  }

  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`

export default Burger
